// Core
import React from 'react';
import { shallowEqual } from 'react-redux';
// Components
import { MixedCharts } from '../common/MixedCharts';
// Hooks:
import { useMixedChartsData } from '../../hooks/useMixedChartsData';
// Other
import { useTypedSelector } from '../../redux';

export const Module2Guide3: React.FC = () => {
  const {
    data: { module2guide3time, module2guide3 },
    mode,
  } = useTypedSelector(({ total }) => total, shallowEqual);
  const { labelsNames, data1, data2 } = useMixedChartsData(mode, module2guide3, module2guide3time);

  return (
    <>
      {labelsNames.length > 0 && (
      <MixedCharts
        theme="green"
        title="Website Module 2 Drop-out / Vinnare Guide"
        subtitle="Amount of sessions per view. And session time per view."
        xLabels={labelsNames}
        data1={data1}
        data2={data2}
      />
      )}
    </>
  );
};
